<mat-card class="collapsible-card">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" class="collapsible-card__header card-header" (click)="toggleOpen()" (keydown.enter)="$event.target === $event.currentTarget && (toggleOpen())">
    <div fxFlex="95" fxLayout="row" fxLayoutAlign="start center">
      @if (displayDelete) {
        <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Delete"
        (click)="$event.stopPropagation(); deleteAction()">
          <i class="material-icons collapsible-card__delete">delete</i>
        </button>
      }
      @if (icon) {
        <img alt="Icon" class="collapsible-card__avatar" [src]="icon"/>
      }
      <div fxLayout="column" fxLayoutAlign="start center">
        <mat-card-title [ngClass]="{'collapsible-card__title-restyled': isRestyled, 'collapsible-card__title': !isRestyled}">
          @if (preTitle) {
            <span class="collapsible-card__pre-title">{{preTitle}}</span>
          }
          <span>{{title}}</span>
          <span class="collapsible-card__post-title">{{postTitle}}</span>
        </mat-card-title>
        @if (subtitle) {
          <div class="collapsible-card__subtitle">
            {{subtitle}}
          </div>
        }
      </div>
    </div>
    <div fxFlex="5">
      <img alt="Chevron Icon Facing Up"
        class="collapsible-card__chevron-icon-up"
        src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"
        [hidden]="!open"/>
      <img alt="Chevron Icon Facing Down"
        class="collapsible-card__chevron-icon-down"
        src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"
        [hidden]="open"/>
    </div>
  </mat-card-header>
  @if (!loading && !error) {
    @if (open) {
      <mat-card-content class="collapsible-card__content" [ngClass]="{'collapsible-card__remove-padding': isRestyled && isMobile}">
        <ng-content></ng-content>
      </mat-card-content>
    }
  }
  @if (loading) {
    @if (open) {
      <mat-card-content class="collapsible-card__content">
        <content-placeholder></content-placeholder>
      </mat-card-content>
    }
  }
  @if (!loading && !!error) {
    @if (open) {
      <mat-card-content class="collapsible-card__content">
        {{error}}
      </mat-card-content>
    }
  }
</mat-card>
